import * as React from "react";

export interface SignShopIconProps {}

export const SignShopIcon = (props: SignShopIconProps) => {
    return (
<svg version="1.1" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 56.1 70.4" enableBackground="new 0 0 56.1 70.4;" className="sign-shop-icon">
<g>
	<path fill="#959595" d="M42.2,20.4V0.2L1.5,5.1v39.7l40.7,4.9v-5.5l7.3-1.8L42.2,20.4z M39.1,47.1l-35.6-4L3.1,6.7l36-3.2L39.1,47.1z"
		/>
	<path fill="#FB9590" d="M24.6,16.2c-1.8,0.2-3.4,1.9-4.1,3.7c-0.8-1.6-2.3-3-4.2-2.9c-2.5,0.2-4.6,2.6-4.5,5.3
		c0.1,5.5,5.3,6.4,8.9,11.6c3.3-5.7,8.6-7.9,8.6-13.2C29.2,18,27.2,16,24.6,16.2L24.6,16.2z"/>
</g>
</svg>
    );
};

